import React from "react";
import {
    TableCell,
    TableRow,
    Box,
    Grid,
    Collapse,
} from '@mui/material';
// import moment from "moment";
import dayjs from 'dayjs';
import GlobalProps from "../../../core/BaseComponents/TableWrapper/Global";
import utc from 'dayjs/plugin/utc';

// Extend dayjs with the utc plugin
dayjs.extend(utc);

const RowListRowSummary = (props) => {
    const { row, columns, open } = props;

    return <TableRow>
        <TableCell style={{ padding: 0, margin: 0, border: 0 }} colSpan={columns.length + 1}>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Box className={'row-details'} padding={2} paddingTop={4} paddingBottom={3} style={{ backgroundColor: "#eceef8" }} >
                    <Grid container justifyContent='space-between' spacing={2}>
                        <Grid item container spacing={0} xs={12} className='grid-block-section'>
                            <Grid item xs={3}>
                                <div className='row-summary-title'>Created By</div>
                                <div className='row-summary-value'>{row.createdBy ? row.createdBy : "N.A"}</div>
                            </Grid>
                            <Grid item xs={3}>
                                <div className='row-summary-title'>Access Till Date</div>
                                <div className='row-summary-value'>{row.accessTillDate ? `${dayjs(row.accessTillDate).format(GlobalProps.dateTimeFormat) !== "Invalid date" && dayjs(row.accessTillDate).format(GlobalProps.dateTimeFormat)}` : "N.A"}</div>
                            </Grid>
                            <Grid item xs={3}>
                                <div className='row-summary-title'>Modified By</div>
                                <div className='row-summary-value'>{row.modifiedBy ? row.modifiedBy : "N.A"}</div>
                            </Grid>
                            <Grid item xs={3}>
                                <div className='row-summary-title'>Modified Date</div>
                                <div className='row-summary-value'>{row.modifiedDate ? `${dayjs(row.modifiedDate).format(GlobalProps.dateTimeFormat) !== "Invalid date" && dayjs(row.modifiedDate).format(GlobalProps.dateTimeFormat)}` : "N.A"}</div>
                            </Grid>
                            {
                                props.module === "userList" && <>
                                    <Grid item xs={3} className="mt-3">
                                        <div className='row-summary-title'>Phone</div>
                                        <div className='row-summary-value'>{row.phoneNo ? row.phoneNo : "N.A"}</div>
                                    </Grid>
                                    {/* <Grid item xs={3} className="mt-3">
                                        <div className='row-summary-title'>Hotel Name</div>
                                        {console.log(row)}
                                        <div className='row-summary-value'>{row.roles[0].role==="Super Admin"?"All":row.hotelName ? row.hotelName : "N.A"}</div>
                                    </Grid> */}
                                </>
                            }
                        </Grid>
                    </Grid>
                </Box>
            </Collapse>
        </TableCell>
    </TableRow>
}

export default RowListRowSummary;